import { MailIcon } from 'assets/icons';
import { createNotification } from 'components/ui';
import { BaseButton } from 'components/ui/buttons';
import { useState } from 'react';
import generatePDF from 'react-to-pdf';
import { sendMail } from 'services/api';

type SendButtonProps = {
  targetRef: React.RefObject<HTMLElement>;
  subject: string;
  content: string;
  filename: string;
};

export const SendButton: React.FC<SendButtonProps> = ({ targetRef, subject, content, filename }) => {
  const [disabled, setDisabled] = useState(false);
  const handleSend = async () => {
    setDisabled(true);
    try {
      const file = await generatePDF(targetRef, { method: 'build' });

      const base64 = await blobToBase64(file.output('blob'));
      await sendMail(subject, content, base64, filename);
      createNotification({
        type: 'success',
        title: 'Email sent successfully',
      });
    } catch (error) {
      createNotification({
        type: 'error',
        title: 'Error sending email',
      });
    } finally {
      setDisabled(false);
    }
  };

  return (
    <BaseButton
      disabled={disabled}
      scheme="secondary"
      icon={MailIcon}
      iconProps={{ className: 'w-[24px] h-[24px]' }}
      onClick={() => {
        handleSend();
      }}
      isIconOnLeftSide
      className="w-1/2 !p-5 !rounded-2xl !leading-[130%] dark:!bg-gray-900 !border-none"
    >
      Send
    </BaseButton>
  );
};

const blobToBase64 = (blob: Blob) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve((reader.result as string).split(',')[1]);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
